const state = {
	loading: false,
	alerts: [],
	alertCount: 0
}

const getters = {
	loading : state => {
    return state.loading
	}
}

const mutations = {
	setLoading: (state, loading) => {
		state.loading = loading
	},
	incrementAlertCount: (state) => {
		state.alertCount++
	},
	addAlert: (state, alert) => {
		state.alerts.push(alert)
	},
	removeAlert: (state, alert) => {
		state.alerts = state.alerts.filter(item => {
			return item.id !== alert.id
		})
	}
}

const actions = {
	addAlert: (context, alert) => {
		alert.id = context.state.alertCount
		context.commit('addAlert', alert)
		context.commit('incrementAlertCount')

		if(alert.timeout) {
			setTimeout(() => {
				context.commit('removeAlert', alert)
			}, alert.timeout)
		}
	}
}

export default {
  namespaced: true,
  state,
  getters,
	mutations,
	actions
}


// WEBPACK FOOTER //
// ./src/store/modules/app.js